export default function useStorage() {
  function preventFullLocalStorage() {
    let totalItems = 0,
      lenght,
      item;
    for (item in localStorage) {
      if (!localStorage.hasOwnProperty(item)) {
        continue;
      }
      lenght = (localStorage[item].length + item.length) * 2;
      totalItems += lenght;
    }
    let kbTotal = (totalItems / 1024).toFixed(2);
    let parsedKbTotal = parseInt(kbTotal);
    //Clean space;
    if (parsedKbTotal > 8000) {
      //Save the auth keys and userDetails.
      let auth_token = localStorage.getItem("auth_token");
      let auth_token_created_at = localStorage.getItem("auth_token_created_at");
      let userDetails = localStorage.getItem("userDetails");
      //Clear the localStorage
      localStorage.clear();
      //Add the necessary itens
      auth_token && localStorage.setItem("auth_token", auth_token);

      auth_token_created_at &&
        localStorage.setItem("auth_token_created_at", auth_token_created_at);

      userDetails && localStorage.setItem("userDetails", userDetails);
    }
    return true;
  }

  return { preventFullLocalStorage };
}
